
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $a79a427e89410a56$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3IszV\",\"CommentEditor.99bfd595.js\",\"gT8XU\",\"page-icon.c82d6bf1.js\",\"ffEVr\",\"vendors~editor_icon.284f7560.js\",\"6wr18\",\"vendors~editor_icon.1a615628.js\",\"kO0mz\",\"audio-icon.5460a466.js\",\"jDjSj\",\"16.1d00245e.js\",\"gQLjx\",\"angle-brackets-icon.76474a3a.js\",\"kDqHr\",\"file-icon.cbc557b5.js\",\"5i5pX\",\"folder-icon.49694abc.js\",\"eA5B3\",\"image-icon.e4ee644a.js\",\"4HZlX\",\"chart-bar-icon.f99ba585.js\",\"7jSfd\",\"list-bullet-icon.4f8ddffc.js\",\"7AsyI\",\"video-icon.ab3d15a5.js\",\"jNyUd\",\"component.30faa9cf.js\",\"2fk6g\",\"16.54cd560a.js\",\"huUvS\",\"16.95572e52.js\",\"1oiJ6\",\"16.f20e72ef.js\",\"lxiFd\",\"16.6f66d48d.js\",\"eDqo1\",\"16.775f562b.js\",\"6HBYC\",\"16.e6a8a945.js\",\"bYxCZ\",\"16.1d6e89c2.js\",\"eTBsW\",\"16.a21a1ba3.js\",\"020xd\",\"16.4d1d2449.js\",\"ls0Um\",\"16.cbe8174e.js\",\"eVYW1\",\"16.71a0c4aa.js\",\"f35QR\",\"16.4bd4939d.js\",\"iivLa\",\"blog.3e042e72.js\",\"dek7I\",\"page-live-doc.3c8d5941.js\",\"gFEtJ\",\"blog-icon.bcfa174e.js\",\"aOY32\",\"branch.76c8a469.js\",\"6fQco\",\"commit.4d39984b.js\",\"1MWOL\",\"pull-request.4b59dadb.js\",\"9wPDc\",\"code.b5cd5c1a.js\",\"9atVd\",\"bug.b5d67b33.js\",\"lm9Lt\",\"changes.0da680de.js\",\"jiFtb\",\"epic.485c97ab.js\",\"4S1SF\",\"incident.4583105e.js\",\"XZauT\",\"problem.808be59e.js\",\"3MYQs\",\"work-item.d9cadfd7.js\",\"5zapo\",\"story.ca19a002.js\",\"9aQIt\",\"subtask.828a8afa.js\",\"6SWFK\",\"task.b3ec32e8.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"lQhaj\",\"priority-blocker-icon.788e81c1.js\",\"iEn0J\",\"priority-critical-icon.83e6abbc.js\",\"d2etG\",\"priority-high-icon.66f03968.js\",\"2rWNg\",\"priority-highest-icon.da70d813.js\",\"akInk\",\"priority-low-icon.337ea45b.js\",\"6zoNk\",\"priority-lowest-icon.bdd817e7.js\",\"1MCFU\",\"priority-major-icon.5ccf213d.js\",\"gz7jV\",\"priority-medium-icon.86c1e72f.js\",\"5Bj6b\",\"priority-minor-icon.01049963.js\",\"89ync\",\"priority-trivial-icon.caeede3d.js\"]"));


$parcel$global.rlb("hvE36")
//# sourceMappingURL=CommentEditor.runtime.a0a08d54.js.map
